<template>
  <SpecieDesktop v-if="!$vuetify.breakpoint.mobile" />
  <SpecieMobile v-else/>
</template>

<script>
import SpecieDesktop from "@/components/Specie/desktop/specie_main_desktop.vue"
import SpecieMobile from "@/components/Specie/mobile/specie_main_mobile.vue"
export default {
  components: {
    SpecieDesktop,
    SpecieMobile
  },
};
</script>